import React, {useState, useEffect, useMemo} from 'react';

import { connect } from 'react-redux';
import { Row, Col, Alert, Input } from 'reactstrap';

import {
    changeOpcoesResultado,
    changeSearchOptions,
    changePlanoEnsinoSearchOptions,
    changeOpcoesNovasAquisicoes,
} from '../../../../store/ducks/pesquisa';

import { Store } from '../../../../store';

import queryString from 'query-string';
import shortid from 'shortid';
import Axios from 'axios';
import { useTranslation } from 'react-i18next';

import { ConsultaAPI } from '../../../../shared/http-requests';
import { ConsultaHelper, APIHelper } from '../../../../shared/helpers';
import ConteudoPesquisaAutoridade from "./contents/ConteudoPesquisaAutoridade";
import ConteudoPesquisaGeralPorIndice from "./contents/ConteudoPesquisaGeralPorIndice";
import ConteudoPesquisaAutomaticaNovasAquisicoes from "./contents/ConteudoPesquisaAutomaticaNovasAquisicoes";
import ConteudoPesquisaCatalogoRedePergamum from "./contents/ConteudoPesquisaCatalogoRedePergamum";
import ConteudoPesquisaAbnt from "./contents/ConteudoPesquisaAbnt";
import ConteudoPesquisaTargetGedWeb from "./contents/ConteudoPesquisaTargetGedWeb";
import ConteudoPesquisaOAI from "./contents/ConteudoPesquisaOAI";
import ConteudoPesquisaGeral from "./contents/ConteudoPesquisaGeral";
import SemConteudo from "./contents/SemConteudo";

const BaseTemplate = React.lazy(() => import('../template/BaseTemplate'));
const HomeHeader = React.lazy(() => import('../../components/Home/HomeHeader'));
const originBlacklist = ['/acervo/', '/cesta', '/autoridade/', '/entrar'];

function Home({
    location,
    match,
    history,
    consultaRx,
    ultimoLogRx,
    statusRx,
    acervosFiltradosRx,
    guiasPesquisaRx,
    opcoesResultadoRx,
    cestaRx,
    opcoesNovasAquisicoes,
    filtrosSelecionados
}) {
    const { t } = useTranslation();
    //? Selecionar todos os checkbox:
    const [selectAll, toggleSelectAll] = useState(false);
    //? Consulta que irá aparecer na tela:
    const [itensConsulta, setItensConsulta] = useState(false);
    //? Opções da combo de ordenação
    const [ordenacao, setOrdenacao] = useState(false);

    const guiaSelecionada =
        match.params.guia ||
        (guiasPesquisaRx &&
            guiasPesquisaRx.length &&
            guiasPesquisaRx.find(guia => guia.ordem === 0)?.codigo);

    /**
     *  Verifica se a guia da URL existe, se não existe, redireciona para a principal
     */
    useEffect(() => {
        if (guiasPesquisaRx && guiasPesquisaRx.length && match.params.guia) {
            if (
                !guiasPesquisaRx.find(
                    guia => guia?.codigo === match.params.guia,
                )
            ) {
                history.push('/');
            }
        }
    }, [match, history, guiasPesquisaRx]);

    /**
     * Faz a pesquisa a partir dos parâmetros da URL
     */
    useEffect(() => {
        if (statusRx && guiasPesquisaRx.length) {
            //* Resgata os parâmetros passado na url:
            const params = queryString.parse(location.search);

            if (Object.values(params).length) {
                //Tratamento para não executar a pesquisa caso a url anterior estiver na blacklist
                if (
                    !location.state ||
                    (location.state &&
                        !originBlacklist.some(o =>
                            location.state.origin.includes(o),
                        ))
                ) {
                    let campos = recuperarCamposParametros(
                        params,
                        guiaSelecionada,
                    );

                    if (!validaCamposPesquisa(campos, guiaSelecionada)) return;
                    ConsultaAPI.buscarConsulta(
                        guiaSelecionada,
                        campos,
                        location,
                    );
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, statusRx, guiasPesquisaRx]);

    useEffect(() => {
        if (consultaRx && consultaRx !== 'error') {
            let consultaFiltrada = [];

            if (acervosFiltradosRx.length > 0) {
                if (consultaRx.base === 'rede_pergamum_oai') {
                    consultaFiltrada = consultaRx.data.filter(acervo =>
                        acervosFiltradosRx.some(a => a === acervo.id),
                    );
                } else {
                    consultaFiltrada = consultaRx.data.filter(acervo =>
                        acervosFiltradosRx.some(a => a === acervo.cod_acervo),
                    );
                }
            } else {
                if(filtrosSelecionados.length){
                    setItensConsulta([]);
                    return;
                }
                consultaFiltrada = consultaRx.data;
            }


            /**
             * Implementação da ordenação
             */

            const fieldOrder = opcoesResultadoRx?.ordenacaoCombo ? opcoesResultadoRx?.ordenacaoCombo : 'obra';

            consultaFiltrada = consultaFiltrada.sort((a,b) => {

                let  argAToOrder = a[fieldOrder];
                let  argBToOrder = b[fieldOrder];

                if (['cod_tipo_obra', 'cod_acervo'].includes(fieldOrder)){
                    argAToOrder = parseInt(argAToOrder)
                    argBToOrder =  parseInt(argBToOrder);
                }


                if(opcoesResultadoRx.ordenacao === "D"){
                    return argAToOrder < argBToOrder ? 1 : -1
                }

                return argAToOrder > argBToOrder ? 1 : -1
            });


            setItensConsulta(
                consultaFiltrada.filter(
                    (registro, index) =>
                        index >=
                            opcoesResultadoRx.quantPag *
                                (opcoesResultadoRx.paginaAtiva - 1) &&
                        index <
                            opcoesResultadoRx.quantPag *
                                opcoesResultadoRx.paginaAtiva &&
                        registro,
                ),
            );
        } else setItensConsulta(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [consultaRx, acervosFiltradosRx, opcoesResultadoRx.quantPag, opcoesResultadoRx.ordenacao, opcoesResultadoRx.ordenacaoCombo]);

    useEffect( () => {
        if(filtrosSelecionados.length === 0 && itensConsulta.length === 0){
            setItensConsulta(consultaRx.data);
        }
    }, [ filtrosSelecionados ])

    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();
        if (!ordenacao && consultaRx) {
            if (validaBuscarOrdenacao()) {
                ConsultaAPI.ordenacao(cancelToken.token)
                    .then(response => {
                        if (response.data.length) setOrdenacao(response.data);
                    })
                    .catch(error => {
                        if (!Axios.isCancel(error)) APIHelper.tratarErro(error);
                    });
            }
        } else if (ordenacao && consultaRx) {
            if (!opcoesResultadoRx.ordenacaoCombo)
                mudarOrdenacaoComboRedux(
                    ordenacao.find(ord => ord.default)?.codigo,
                );
            if (consultaRx.id !== ultimoLogRx.id) setOrdenacao(false);
        }
        //? cleanup
        return () => cancelToken.cancel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ordenacao, consultaRx.id]);

    const mudarOrdenacaoComboRedux = codigo => {
        Store.dispatch(
            changeOpcoesResultado({
                ...opcoesResultadoRx,
                ordenacaoCombo: codigo,
            }),
        );
    };

    /**
     * Cada vez que o usuário selecionar um item, trocar a página, ou a ordenação
     * valida se todos os itens da tela estão na cesta para marcar o selectAll
     */
    useEffect(() => {
        if (itensConsulta) {
            let todosCesta = itensConsulta.every(item =>
                cestaRx.some(i => i.cod_acervo === item.cod_acervo),
            );
            if (todosCesta !== selectAll) toggleSelectAll(todosCesta);
        }
    }, [cestaRx, opcoesResultadoRx.paginaAtiva, itensConsulta, selectAll]);

    const recuperarCamposParametros = (parametros, tipoPesquisa) => {
        let fields = {};
        //Campos da pesquisa geral
        if (
            tipoPesquisa === 'pesquisa_geral' ||
            tipoPesquisa === 'e_books' ||
            tipoPesquisa === 'autoridades' ||
            tipoPesquisa === 'acessibilidade' ||
            tipoPesquisa === 'novas_aquisicoes'
        ) {
            if (!!parametros.tipo_obra_total) {
                let tipo_obra_total =
                    parametros.tipo_obra_total.slice(-1) === ','
                        ? parametros.tipo_obra_total
                        : parametros.tipo_obra_total + ',';
                fields = {
                    termo_pesquisa: 'tipo_obra_total',
                    coluna_um: parametros.for,
                    autoridade: parametros.aut_id,
                    indice: parametros.index,
                    base: parametros.rep,
                    tipo_obra_total: tipo_obra_total,
                };
            } else {
                fields = {
                    termo_pesquisa: parametros.q,
                    coluna_um: parametros.for,
                    autoridade: parametros.aut_id,
                    indice: parametros.index,
                    base: parametros.rep,
                };
            }

            //Validacao dos valores de redirecionamento - Legado
            if (!!parametros.cr) {
                let cr =
                    parametros.cr.toUpperCase() === 'S'
                        ? parametros.cr.toUpperCase()
                        : 'N';
                fields = {
                    ...fields,
                    bib_virtual: cr,
                };
            }
            if (!!parametros.id_biblioteca) {
                let id_biblioteca =
                    parametros.id_biblioteca.slice(-1) === ','
                        ? parametros.id_biblioteca
                        : parametros.id_biblioteca + ',';
                fields = {
                    ...fields,
                    biblioteca: id_biblioteca,
                };
            }
            if (!!parametros.id_colecao) {
                let id_colecao =
                    parametros.id_colecao.slice(-1) === ','
                        ? parametros.id_colecao
                        : parametros.id_colecao + ',';
                fields = {
                    ...fields,
                    colecao: id_colecao,
                };
            }
            if (!!parametros.tipo_obra) {
                let tipo_obra =
                    parametros.tipo_obra.slice(-1) === ','
                        ? parametros.tipo_obra
                        : parametros.tipo_obra + ',';
                fields = {
                    ...fields,
                    cod_tipo_obra: tipo_obra,
                };
            }
            if (!!parametros.id) {
                fields = {
                    ...fields,
                    id_campus: parametros.id,
                };
            }
        }
        if (
            tipoPesquisa === 'arquivo' ||
            tipoPesquisa === 'pesquisa_avancada' ||
            tipoPesquisa === 'atos_normativos'
        ) {
            fields = {
                termo_pesquisa: parametros.q,
                coluna_um: parametros.for,
            };

            if (
                !!parametros.for2 ||
                !!parametros.q2 ||
                !!parametros.condition
            ) {
                fields = {
                    ...fields,
                    termo_pesquisa_dois: parametros.q2,
                    coluna_dois: parametros.for2,
                    condicao_um: parametros.condition,
                };
            }

            if (
                !!parametros.for3 ||
                !!parametros.q3 ||
                !!parametros.condition2
            ) {
                fields = {
                    ...fields,
                    termo_pesquisa_tres: parametros.q3,
                    coluna_tres: parametros.for3,
                    condicao_dois: parametros.condition2,
                };
            }

            if (tipoPesquisa === 'pesquisa_avancada') {
                fields = { ...fields, tipo_termos: parametros.keyword_type };
            }
        }

        if(tipoPesquisa == 'plano_ensino'){
            fields = {
                tipo_termos: 99
            };
            let {curso, disciplina, campus, biblioteca, professor} = parametros;



            if(campus){
                fields.cod_campus_selecao = campus;
            }

            if(biblioteca){
                fields.biblioteca = biblioteca
            }


            let items =  [
                {coluna: 'CURSO', termo : curso },
                {coluna: 'DISCIPLINA', termo: disciplina},
                {coluna: 'PROFESSOR', termo: professor}
            ].filter( item => typeof item.termo != 'undefined')


            let assoc = ['um', 'dois', 'tres'];

            items.map( (item, index) => {
                fields[`coluna_${assoc[index]}`] = item.coluna
                let stringEnd = index == 0 ? '' : `_${assoc[index]}`;
                fields[`termo_pesquisa${stringEnd}`] = item.termo
                fields[`condicao_${assoc[index]}`] = 'AND';
            })


        }
        //Parametros fixos
        fields = {
            ...fields,
            search_id: shortid.generate(),
            search_tab: tipoPesquisa,
        };
        return fields;
    };

    const validaCamposPesquisa = (campos, tipoPesquisa) => {
        if (
            tipoPesquisa === 'pesquisa_geral' ||
            tipoPesquisa === 'e_books' ||
            tipoPesquisa === 'autoridades' ||
            tipoPesquisa === 'acessibilidade'
        ) {
            if (!campos.base) {
                // Condições de pesquisa caso o item seja PESQUISA GERAL, EBOOKS, ACESSIBILIDADE OU AUTORIDADES:
                if (!campos.termo_pesquisa || !campos.coluna_um) return false;
                Store.dispatch(
                    changeSearchOptions([
                        {
                            option: campos.coluna_um,
                            termo: campos.termo_pesquisa,
                        },
                    ]),
                );
                return true;
            } else {
                //Quando for pesquisa em outras bases, valida apenas o termo
                if (!campos.termo_pesquisa) return false;
                Store.dispatch(
                    changeSearchOptions([
                        { option: 'LIVRE', termo: campos.termo_pesquisa },
                    ]),
                );
                return true;
            }
        } else if (
            tipoPesquisa === 'arquivo' ||
            tipoPesquisa === 'pesquisa_avancada' ||
            tipoPesquisa === 'atos_normativos'
        ) {
            // Condições de pesquisa caso o item seja PESQUISA AVANCADA, ARQUIVO ou ATOS NORMATIVOS:
            let novaOpcoesConsulta = [];
            //Valida campos da primeira linha
            if (campos.termo_pesquisa && campos.coluna_um) {
                let linha1 = {
                    option: campos.coluna_um,
                    termo: campos.termo_pesquisa,
                    condition: campos.condicao_um,
                };
                novaOpcoesConsulta.push(linha1);
            } else return false;

            //Valida campos da segunda linha
            if (
                campos.condicao_um ||
                campos.termo_pesquisa_dois ||
                campos.coluna_dois
            ) {
                if (
                    campos.condicao_um &&
                    campos.termo_pesquisa_dois &&
                    campos.coluna_dois
                ) {
                    let linha2 = {
                        option: campos.coluna_dois,
                        termo: campos.termo_pesquisa_dois,
                        condition: campos.condicao_dois,
                    };
                    novaOpcoesConsulta.push(linha2);
                } else return false;
            }

            //Valida campos da terceira linha
            if (
                campos.condicao_dois ||
                campos.termo_pesquisa_tres ||
                campos.coluna_tres
            ) {
                if (
                    campos.condicao_dois &&
                    campos.termo_pesquisa_tres &&
                    campos.coluna_tres
                ) {
                    let linha3 = {
                        option: campos.coluna_tres,
                        termo: campos.termo_pesquisa_tres,
                    };
                    novaOpcoesConsulta.push(linha3);
                } else return false;
            }

            //Valida semantica dos conectores condicionais
            if (
                novaOpcoesConsulta.some(
                    o =>
                        o.condition &&
                        ['AFT', 'BEF', 'PRO'].includes(o.condition),
                )
            ) {
                if (
                    novaOpcoesConsulta.some(
                        (o, index) =>
                            o.condition &&
                            ['AFT', 'BEF', 'PRO'].includes(o.condition) &&
                            index !== 0,
                    )
                )
                    return false;
                if (novaOpcoesConsulta[0].option === 'LIVRE') return false;
                if (novaOpcoesConsulta.length === 3) return false;
                if (
                    novaOpcoesConsulta[0].option !==
                    novaOpcoesConsulta[1].option
                )
                    return false;
            }
            Store.dispatch(changeSearchOptions(novaOpcoesConsulta));
            return true;
        } else if (tipoPesquisa === 'novas_aquisicoes') {
            if (
                !campos.coluna_um ||
                (campos.coluna_um !== 'TODOS' && !campos.termo_pesquisa)
            )
                return false;
            if (campos.coluna_um === 'TODOS')
                Store.dispatch(
                    changeSearchOptions([{ option: 'TITULO', termo: '' }]),
                );
            else
                Store.dispatch(
                    changeSearchOptions([
                        {
                            option: campos.coluna_um,
                            termo: campos.termo_pesquisa,
                        },
                    ]),
                );
            return true;
        } else if(tipoPesquisa == 'plano_ensino'){
            const params = queryString.parse(location.search);

            Store.dispatch(
                changePlanoEnsinoSearchOptions(
                    {
                        curso: {
                            key: params.curso ??"",
                            value: params.curso ?? "",
                            displayValue: params.curso_displayValue ?? "",
                            searchValue: params.curso_searchValue ?? ""
                        },
                        biblioteca: {value: params.biblioteca ?? ""},
                        professor: {value: params.professor ?? ""},
                        campus: {value: params.campus ?? ""},
                        disciplina: {
                            key: params.disciplina ??"",
                            value: params.disciplina ?? "",
                            displayValue: params.disciplina_displayValue ?? "",
                            searchValue: params.disciplina_searchValue ?? ""
                        }
                    }
                ),
            );


            return true
        }
    };

    const validaBuscarOrdenacao = () => {
        const urlParams = queryString.parse(location.search);
        if (guiaSelecionada === 'autoridades' && !urlParams.aut_id)
            return false;
        if (
            guiaSelecionada === 'pesquisa_geral' &&
            ((urlParams.for &&
                urlParams.for.endsWith('_INDICE') &&
                urlParams.for !== 'TITULO_INDICE' &&
                !urlParams.index) ||
                consultaRx.base !== 'local')
        )
            return false;
        return true;
    };

    const limparConsulta = () => {
        ConsultaHelper.limparConsulta(() => setItensConsulta(false));
    };

    const mudarQuantidadePerPag = quant => {
        quant = parseInt(quant);
        Store.dispatch(
            changeOpcoesResultado({
                ...opcoesResultadoRx,
                quantPag: quant,
                paginaAtiva: 1,
            }),
        );
    };

    const mudarPaginaResultado = pagina => {
        if (pagina !== opcoesResultadoRx.paginaAtiva) {
            let consultaFiltrada = [];

            if (acervosFiltradosRx.length > 0) {
                if (consultaRx.base === 'rede_pergamum_oai') {
                    consultaFiltrada = consultaRx.data.filter(acervo =>
                        acervosFiltradosRx.some(a => a === acervo.id),
                    );
                } else {
                    consultaFiltrada = consultaRx.data.filter(acervo =>
                        acervosFiltradosRx.some(a => a === acervo.cod_acervo),
                    );
                }
            } else {
                consultaFiltrada = consultaRx.data;
            }

            setItensConsulta(
                consultaFiltrada.filter(
                    (registro, index) =>
                        index >= opcoesResultadoRx.quantPag * (pagina - 1) &&
                        index < opcoesResultadoRx.quantPag * pagina &&
                        registro,
                ),
            );
            Store.dispatch(
                changeOpcoesResultado({
                    ...opcoesResultadoRx,
                    paginaAtiva: pagina,
                }),
            );
            document
                .querySelector('.consultaContent')
                .scrollIntoView({ behavior: 'smooth' });
        }
    };

    /**
     * Altera o tipo de exibicao (Listas/Capas)
     * @param value
     */
    const mudarModoExibicaoNovasAquisicoes = (value) => {
        let novaOpcoesResultado = {
            ...opcoesNovasAquisicoes,
            exibicao: value,
        };
        Store.dispatch(changeOpcoesNovasAquisicoes(novaOpcoesResultado));
    }

    /**
     * Header especifico do tipo de pesquisa novas_aquisicoes
     * Possui somente o combobox de seleção de modo de  exibição: (Listas/Capas)
     * @returns {JSX.Element}
     */
    const renderizarHeaderNovasAquisicoes = () => {
        return (<Row style={{width: '100%'}}>
                <div className="pl-0 col-12">
                    <div className="row b-w1 b-cinza row" style={{width: '100%', justifyContent: 'flex-end'}}>
                        <div className="pt-3 col-sm-12 col-md-2">
                            <div>
                                <div>
                                                    <span className="s13 cortxt f500">
                                                        {t('ModoExibicao')}:
                                                    </span>
                                </div>
                                <Input
                                    type="select"
                                    name="modo_exibicao"
                                    value={opcoesNovasAquisicoes.exibicao}
                                    onChange={e => mudarModoExibicaoNovasAquisicoes(e.target.value)}
                                >
                                    <option value={'L'}>{t('Listas')}</option>
                                    <option value={'C'}>{t('Capas')}</option>
                                </Input>
                            </div>
                        </div>
                    </div>
                </div>
            </Row>)
    }

    /**
     * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
     * Condições para a renderização da tela, movidas para melhor leiturado código
     * @returns {{CONDICAO_PESQUISA_OAI: (function(): boolean),
     * CONDICAO_PESQUISA_ABNT: (function(): boolean),
     * CONDICAO_PESQUISA_GERAL_POR_INDICE: (function()),
     * CONDICAO_PESQUISA_TARGET_GED_WEB: (function(): boolean),
     * CONDICAO_PESQUISA_AUTORIDADE: (function()),
     * CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM: (function(): boolean),
     * CONDICAO_PESQUISA_GERAL: (function(): *),
     * CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES: (function())}}
     */
    const conditions = () => {

        const { pesquisa, base } = consultaRx;

        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_AUTORIDADE = () =>  !!(pesquisa === 'autoridades' && itensConsulta.some(a => !!a.cod_autoridade));
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_GERAL_POR_INDICE =  () =>  !!((pesquisa === 'pesquisa_geral' && itensConsulta.every(a => a.obra && a.obra.trim() === '')));
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES = () =>
            !!((pesquisa === 'novas_aquisicoes' && itensConsulta &&
                itensConsulta.some(a => ((a?.areas_conhecimento.length > 0) || (a?.cursos_disc.length > 0))) &&
                acervosFiltradosRx.length === 0 && opcoesNovasAquisicoes.exibicao === 'L'));
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM = () =>  (base === 'rede_pergamum');
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_ABNT = () => (base === 'abnt');
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_TARGET_GED_WEB = () => (base === 'target_gedweb');
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_OAI = () => (['rede_pergamum_oai', 'oai_local'].includes(base)) ;
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_GERAL = () => !!( (filtrosSelecionados.length > 0) || itensConsulta.every(i => i.cod_empresa));


        return {
            CONDICAO_PESQUISA_AUTORIDADE,
            CONDICAO_PESQUISA_GERAL_POR_INDICE,
            CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES,
            CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM,
            CONDICAO_PESQUISA_ABNT,
            CONDICAO_PESQUISA_TARGET_GED_WEB,
            CONDICAO_PESQUISA_OAI,
            CONDICAO_PESQUISA_GERAL
        }
    }



    const getContent = () => {
        let usaHeader = true;
        let usaModoExibicao = false;
        let content = null;

        if(!consultaRx || !itensConsulta || consultaRx === 'error'){

            return null;
        }

        try{
            if(itensConsulta?.length === 0){
                usaHeader = false;
                /**
                 * Sem conteúdo - Alertas
                 * @type {JSX.Element}
                 */
                if(filtrosSelecionados.length > 0){
                    content = (<ConteudoPesquisaGeral
                        toggleSelectAll={toggleSelectAll}
                        selectAll={selectAll}
                        itensConsulta={itensConsulta}
                    />)
                }else{
                    content = <SemConteudo />
                }
            }else{
                const {
                    CONDICAO_PESQUISA_AUTORIDADE, CONDICAO_PESQUISA_GERAL_POR_INDICE,
                    CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES, CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM,
                    CONDICAO_PESQUISA_ABNT, CONDICAO_PESQUISA_TARGET_GED_WEB,
                    CONDICAO_PESQUISA_OAI, CONDICAO_PESQUISA_GERAL
                }  = conditions();


                switch (true){
                    case CONDICAO_PESQUISA_AUTORIDADE():
                        /**
                         * Conteúdo Pesquisa autoridade
                         * @type {JSX.Element}
                         */
                        content = <ConteudoPesquisaAutoridade itensConsulta={itensConsulta} />
                        break;
                    case CONDICAO_PESQUISA_GERAL_POR_INDICE():
                        /**
                         * Conteúdo Pesquisa Geral por indice
                         * @type {JSX.Element}
                         */
                        content = <ConteudoPesquisaGeralPorIndice  itensConsulta={itensConsulta} />
                        break;
                    case CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES():
                        usaHeader = false;
                        /**
                         * Conteúdo Pesquisa automática novas aquisições
                         * @type {JSX.Element}
                         */
                        content = <ConteudoPesquisaAutomaticaNovasAquisicoes />
                        break;
                    case CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM():
                        /**
                         * Conteúdo Pesquisa Catalogo Rede Pergamum
                         * @type {JSX.Element}
                         */
                        content = <ConteudoPesquisaCatalogoRedePergamum itensConsulta={itensConsulta} />
                        break;
                    case CONDICAO_PESQUISA_ABNT():
                        /**
                         * Conteúdo Pesquisa ABNT
                         * @type {JSX.Element}
                         */
                        content = <ConteudoPesquisaAbnt itensConsulta={itensConsulta} />
                        break;
                    case CONDICAO_PESQUISA_TARGET_GED_WEB():
                        content = <ConteudoPesquisaTargetGedWeb itensConsulta={itensConsulta} />
                        break;
                    case CONDICAO_PESQUISA_OAI():
                        /**
                         * Conteúdo Pesquisa OAI
                         * @type {JSX.Element}
                         */
                        content = <ConteudoPesquisaOAI itensConsulta={itensConsulta} />
                        break;
                    case CONDICAO_PESQUISA_GERAL():
                        usaModoExibicao = true;
                        /**
                         * Conteúdo Pesquisa Geral
                         * @type {JSX.Element}
                         */
                        content = <ConteudoPesquisaGeral
                            toggleSelectAll={toggleSelectAll}
                            selectAll={selectAll}
                            itensConsulta={itensConsulta} />
                        break;
                    default:
                        return null;
                }
            }
        }catch (ex){
            return null;
        }


        return (
            <div className="consultaContent col-md-12">
                <Row className="bkbranco pt-2 pb-2 pl-0 pr-0 rad5 b-w2 b-tema10 b-solid">
                    {usaHeader && (
                        <HomeHeader
                            showheader
                            ordenacao={ordenacao}
                            mudarPaginaResultado={mudarPaginaResultado}
                            limparConsulta={limparConsulta}
                            mudarQuantidadePerPag={mudarQuantidadePerPag}
                            guiaSelecionada={guiaSelecionada}
                            showModoExibicao={usaModoExibicao}
                        />
                    ) || guiaSelecionada === 'novas_aquisicoes' && renderizarHeaderNovasAquisicoes()}
                    <Col xs="12" className="p-0">
                        <Row
                            className={`mt-3 pt-1 pb-3 ${
                                usaHeader && 'border-top'
                            }`}
                        >
                            {content}
                        </Row>
                    </Col>
                    {usaHeader && (
                        <HomeHeader
                            ordenacao={ordenacao}
                            mudarPaginaResultado={mudarPaginaResultado}
                            limparConsulta={limparConsulta}
                            mudarQuantidadePerPag={mudarQuantidadePerPag}
                            guiaSelecionada={guiaSelecionada}
                            showModoExibicao={usaModoExibicao}
                        />
                    )}
                </Row>
            </div>
        )
    }

    return (
        <BaseTemplate guiaSelecionada={guiaSelecionada}>
            {getContent()}
        </BaseTemplate>
    );
}

const mapStateToProps = state => ({
    consultaRx: state.pesquisa.consulta,
    acervosFiltradosRx: state.pesquisa.acervosFiltrados,
    ultimoLogRx: state.pesquisa.log[state.pesquisa.log.length - 1],
    statusRx: state.pageConfig.status,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    opcoesResultadoRx: state.pesquisa.opcoesResultado,
    opcoesNovasAquisicoes: state.pesquisa.opcoesNovasAquisicoes,
    cestaRx: state.cesta.itens,
    filtrosSelecionados: state.pesquisa.filtros
});

export default connect(mapStateToProps)(Home);
